"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var TextInput_1 = __importDefault(require("../../../common/inputs/TextInput"));
var Select_1 = __importDefault(require("../../../common/inputs/Select"));
var EditProductSpecificationBasic = function (_a) {
    var productSpec = _a.productSpec, onChange = _a.onChange;
    var keyTimerRef = react_1.useRef(null);
    react_1.useEffect(function () {
        return function () { return clearTimeout(keyTimerRef.current); };
    }, []);
    var keyUpHandler = function (e) {
        var name = e.currentTarget.name;
        var value = e.currentTarget.value;
        clearTimeout(keyTimerRef.current);
        keyTimerRef.current = setTimeout(function () {
            onChange(name, value);
        }, 500);
    };
    return (react_1.default.createElement("div", { className: 'edit-product-spec-basic form' },
        react_1.default.createElement("span", { className: 'title' }, "Basic Information"),
        react_1.default.createElement(TextInput_1.default, { type: 'text', name: 'name', placeholder: 'Specification Name', defaultValue: productSpec.name, onKeyUp: keyUpHandler }),
        react_1.default.createElement("div", { className: 'select-with-new-entry' },
            react_1.default.createElement("div", { className: 'select-with-new-entry__section flex flex-row' },
                react_1.default.createElement("span", { className: 'select-with-new-entry__label' }, "Filterable?:"),
                react_1.default.createElement(Select_1.default, { value: productSpec.filterable, onChange: function (value) { return onChange('filterable', value); }, options: [{ value: true, text: 'Yes' },
                        { value: false, text: 'No' }] })))));
};
exports.default = EditProductSpecificationBasic;
